module.exports = __webpack_public_path__ + "img/no-data_group.70f25ea5.svg";